
const AwsExports = {
    Auth: {
        identityPoolId: 'ap-northeast-1:094155fc-6d95-402a-9143-66da7a0afe71',
        region: 'ap-northeast-1',
    },
    API: {
        'aws_appsync_graphqlEndpoint': 'https://wl7ix5dj4rbhdni7naeued5z3m.appsync-api.ap-northeast-1.amazonaws.com/graphql',
        'aws_appsync_region': 'ap-northeast-1',
        'aws_appsync_authenticationType': 'AWS_IAM',
    },
};

export default AwsExports;
